/** What fires a connector's schedule entry: a cron expression, a fixed interval, or a change. */
export const SyncTriggerKind = {
  CRON: 'cron',
  INTERVAL: 'interval',
  EVENT: 'event'
} as const;

export type SyncTriggerKind = (typeof SyncTriggerKind)[keyof typeof SyncTriggerKind];
